import { createToastInterface } from "vue-toastification";

export default function (ctx, inject) {
  const toast = createToastInterface({"cssFile":"\u002Fusr\u002Fsrc\u002Fapp\u002Fnode_modules\u002Fvue-toastification\u002Fdist\u002Findex.css","position":"bottom-center","hideProgressBar":true,"closeButton":false,"transition":"bounce","timeout":2500,"maxToasts":1,"filterBeforeCreate":(toast, toasts) => {
      if (toasts.filter(
        (t) => t.type === toast.type || t.content === toast.content
      ).length) {return false;}
      return toast;
    }});
  inject('toast', toast);
}
